import { useState, useEffect } from '@max/max';
import { useMonitorEngineContext, useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH, getRequestPlatform, getRequestSource } from '../utils/request';
import { DEFAULT_LOCATION } from '../const/index';
import { navigateToDetailPage } from '../utils/navigate';
import { getUTMParams } from '../utils/utm';
const pageNo = 1;
const pageSize = 15;
const flowSource = 6; // 流量来源固定为6
export const useCore = (feConfig) => {
    const ctx = useMonitorEngineContext();
    const queryParams = ctx._runtimeInfo.queryParams;
    const { monitorNavigateTo } = useMonitorNavigation();
    const [visible, setVisible] = useState(false);
    // 根据 queryParams 上有无 inviteUserId 参数判断是否是主态
    // const isMainState = !queryParams?.inviteUserId;
    const [isMainState, setIsMainState] = useState(!queryParams?.inviteUserId);
    // const isMainState = true;
    const sharePoiList = queryParams?.sharePoiList ? JSON.parse(queryParams?.sharePoiList) : [];
    const { request, response, isLoading, isSuccess, isError } = useRequest();
    const { uuid, platform, userId, token, clientContainer, appVersion, lat, lng, cityId, locCityId } = ctx._runtimeInfo.commonParams;
    // 异步构建完整的API参数（包含位置信息获取）
    const getSupplyParams = (poiInfoList) => {
        return {
            flowSource,
            userId: Number(userId) || 0,
            token: token || '',
            platform: getRequestPlatform(platform),
            source: getRequestSource(clientContainer),
            uuid: uuid || '00000000000000A286FCFD3B9467D8FA885B22B670870A174862398215104327',
            poiInfoList: poiInfoList,
            // poiInfoList: [{
            //   poiId: "192186894",
            //   latitude: "29.561174",
            //   longitude: "106.573349"
            // }],
            lat: lat || DEFAULT_LOCATION.lat,
            lng: lng || DEFAULT_LOCATION.lng,
            pageNo,
            pageSize,
            inviteUserId: queryParams?.inviteUserId ? Number(queryParams.inviteUserId) : undefined,
            cityId: cityId || DEFAULT_LOCATION.cityId,
            locateCityId: cityId || DEFAULT_LOCATION.cityId,
            pushPurchaseText: feConfig.pushPurchaseText,
            ...getUTMParams(queryParams)
            // UTM 参数
            //   utm_campaign: queryParams?.utm_campaign,
            //   utm_content: queryParams?.utm_content || uuid,
            //   utm_medium: queryParams?.utm_medium,
            //   utm_source: queryParams?.utm_source,
            //   utm_term: queryParams?.utm_term,
            //   version_name: queryParams?.version_name || appVersion,
        };
    };
    // 发起API请求
    const fetchSupplyData = (poiInfoList) => {
        try {
            const params = getSupplyParams(poiInfoList);
            request({
                requestConfig: {
                    path: API_PATH.SUPPLY_LIST,
                    method: 'POST',
                    params
                },
                onSuccess: data => {
                    console.log('Supply data fetched successfully:', data);
                },
                onError: error => {
                    console.error('Failed to fetch supply data:', error);
                }
            });
        }
        catch (error) {
            console.error('Error building supply params:', error);
        }
    };
    // 初始化：直接发起API请求
    useEffect(() => {
        if (!isMainState) {
            fetchSupplyData(sharePoiList);
            setVisible(true);
        }
        // fetchSupplyData([{
        //     poiId: "192186894",
        //     latitude: "29.561174",
        //     longitude: "106.573349"
        //   }]);
        // setVisible(true);
        ctx?._communication?.on('callPriceComparisonComponent', ({ poiInfoList = [] }) => {
            console.log('callPriceComparisonComponent', poiInfoList);
            fetchSupplyData(poiInfoList);
            setVisible(true);
            setIsMainState(true);
        });
        return () => {
            ctx?._communication?.off('callPriceComparisonComponent');
        };
    }, []);
    const navigateToDetail = (poiId) => {
        navigateToDetailPage({
            poiId: poiId,
            shopuuid: poiId,
            hotelchannel: '-999'
        }, monitorNavigateTo);
    };
    const toast = (message, duration = 2000) => {
        ctx?._uiInteractionAPI.toast.show({
            content: message,
            duration: duration
        });
    };
    const changeComparePoi = () => {
        if (response?.data?.remainRecPoiInfo?.length) {
            const poiInfo = {
                poiId: response?.data?.remainRecPoiInfo?.[0]?.poiId,
                latitude: response?.data?.remainRecPoiInfo?.[0]?.lat,
                longitude: response?.data?.remainRecPoiInfo?.[0]?.lng
            };
            fetchSupplyData([poiInfo]);
        }
    };
    return {
        visible,
        setVisible,
        ctx,
        // 基础状态
        isMainState,
        sharePoiList,
        userInfo: {
            userId,
            token,
            uuid,
            lat,
            lng,
            cityId,
            locCityId
        },
        // 请求状态
        isLoading,
        isSuccess,
        isError,
        // 响应数据
        response,
        // 操作方法
        refetch: fetchSupplyData,
        navigateToDetail,
        toast,
        changeComparePoi,
        // 计算属性
        hasData: isSuccess && response !== null,
        // 数据列表
        productInfoList: response?.data?.productInfoList || [],
        surroundingRecSupplyList: response?.data?.surroundingRecSupplyList || [],
        user: response?.data?.user
    };
};
